import styled from "@emotion/styled";
import { Column } from "~/components/common/Modal/Modal.style";

export const ColumnWithPadding = styled(Column)`
  padding-top: 4px;
  padding-bottom: 4px;
`;